export default {
    // 公共模块
    common: {
        simplifiedChinese: '简体中文',
        ChineseTraditional: '繁體中文',
        English: 'English',
        personalCenter: '个人中心',
        contactCustomerService: '联系客服',
        logOut: '退出登录',
        home: '首页',
        deviceManagement: '设备管理',
        roleAssignment: '角色分配',
        powerDistribution: '权限分配',
        accountManagement: '账号管理',
        pleaseEnterName: '请输入',
        pleaseSelectName: '请选择',
        date: '内容',
        serial: '序号',
        operation: '操作',
        empty: '清空',
        query: '查询',
        del: '删除',
        operateSuccess: '操作成功',
        passwd: '密码',
        remark: '备注',
        isDisabled: '是否禁用',
        disabled: '禁用',
        notDisabled: '启用',
        pleaseEnter: '请输入',
        pleaseSelect: '请选择',
        roleName: '角色名称',
        jurisdictionIds: '权限id',
        addingRoles: '添加角色',
        editRole: '编辑角色',
        addRights: '增加权限',
        changePermission: '修改权限',
        PermissionName: '权限名称',
        authorityCredentials: '权限值',
        nameAccount: '账号名称',
        roleId: '权限id',
        addAccount: '添加账号',
        modifyAccount: '修改账号',
        ClientManagement: '用户管理',
        addUser: '增加用户',
        passwordPrompt: '请输入6位以上英文+数字的组合密码',
        telephone: '电话号码',
        languageSwitch: '语言切换',
        verificationCode: '验证码',
        logIn: '登录',
        getCode: '获取验证码',
        afterObtaining: 's后获取',
        pleaseWait: '请稍候...',
        loginFailure: '登录失败',
        WelcomeTo: '欢迎登陆',
        DeviceUuid: '设备uuid',
        deviceInterface: '添加设备',
        changeDeviceInterface: '修改设备',
        bindingInterface: '绑定设备Wi-Fi',
        wifi: 'Wi-Fi',
        add: '添加',
        name: "姓名",
        email: "邮箱",
        createTime: "创建时间",
        lastTime: "修改时间",
        edit: "编辑",
        Cancel: "取消",
        Confirm: "确认",
        pleaseEnterSamePassword: "请输入相同的密码",
        weekday: "工作日",
        startTime: "开始时间",
        endTime: "结束时间",
        sex: '性别',
        deviceList: '设备列表',
        workingSchedule: '工作排班',
        workforceManagement: "排班管理",
        credentialManagement: "证件管理",
        workerManagement: "员工管理",
        facePhoto: "人脸照片",
        photo: "照片",
        scheduling: "排班",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Weekday: "周日",
        IdentificationCard: "认别证（蓝卡）",
        MacauResidentIdentityCard: "澳门居民身份证",
        certificateType: "证件类型",
        certificateTimeStart: "证件有效期开始",
        certificateTimeEnd: "证件有效期结束",
        MasterCardNot: "是否主卡",
        yes: "是",
        no: "否",
        IDNumber: "证件号码",
        OnlyOneImage: "只能上传一张图片",
        pictureSize: "上传图片大小不能超过{size}MB!",
        pictureFormat: "上传图片只能是 {type} 格式!",
        ChangePassword: "修改密码",
        AttendanceManagement: "考勤管理",
        DeviceNoteInformation: "设备备注信息",
        DeviceSNCode: "设备sn码",
        OnlineOrNot: "是否在线",
        DeleteWhitelist: "删除白名单",
        RemoteDoorOpening: "远程开门",
        RemoteRestartOfDevices: "远程重启设备",
        DeleteDeviceRecords: "删除设备记录",
        CompanyName: "粤港澳大湾区科技传播",
        SyncToDevice: "同步到设备",
        DataStatistics: "数据统计",
        PersonnelManagementSystem: "人员管理系统",
        NotConfigured: "暂未配置",
        EmployeeInformationEditing: "员工信息编辑",
        EmployeeCredentialsEditor: "员工证件编辑",
        AddEmployeeCredentials: "添加员工证件",
        CertificateRemarks: "证件备注",
        user: "用户",
        employee: "员工",
        type: "类型",
        triggeringTime: "触发时间",
        ExportForm1: "导出打卡记录",
        ExportForm2: "导出全部打卡时间",
        equipment: "设备",
        AssociatedWithTheScheduledWorkers: "关联排班的员工",
        dateRange: "日期范围",
        snCode: "SN码",
        DeviceSn: "设备sn码（请直接到设备上查看）",
        StartDate: "开始日期",
        EndDate: "结束日期",
        ClockIn: "上班卡",
        ClockOut: "下班卡",
        leave: "请假",
        takeVacation: "休假",
        annualLeave: "年假",
        evection: "出差",
        rests: "其他",
        man: "男",
        woman: "女",
        CrossDayOrNot: "是否跨日",
        IDPhoto: "证件照片",
        dateOnBoard: "入职日期",
        dateOfDeparture: "离职日期",
        emergencyContact: "紧急联系人",
        EmergencyContactNumber: "紧急联系人电话",
        EmployeeID: "员工编号",
        hourlyWage: "时薪",
        dailyWage: "日薪",
        monthlyPay: "月薪",
        SalaryCalculationMethod: "薪资计算方式",
        remuneration: "薪资",
        pleaseUpload: "请上传{name}",
        requiredField: "必填字段",
        to: "至",
        AdditionalShift: "添加班次",
        classes: "班次",
        TimeRequiredForAttendance: "应出勤时长",
        intermission: "中间休息时间",
        SchedulingType: "排班类型",
        FixedSchedule: "固定排班",
        IntelligentSchedule: "智能排班",
        jobcard: "职安卡",
        macao: "澳门居民身份证",
        laborid: "外地劳工证",
        hkid: "香港居民身份证",
        chinaid: "内地居民身份证",
        chinapermit: "内地居民通行证",
        more: "更多",
        AddMaximum: "班次最多添加{numb}个",
        noData: '暂无数据',
        attentionPleaseTips: '请注意!以下证件即将过期,请提前进行处理',
        systematicNotification: '系统通知',
        officeHours: '上班时间',
        closingTime: '下班时间',
        ClockingTime: '打卡时间',
        ProcessingFailure: "处理失败，如有疑问请联系管理员",
        OffLine: "离线",
        OnLine: "在线",
        tips1: "请注意您员工编号：{num}有可能重复了，如确认无重复请联系管理员",
        tips2: "请注意您证件编号：{num}有可能重复了，如确认无重复请联系管理员",
        hourFormat: "(小时制)可小数",
        ExportForm3: "导出排班表",
        MenuPermission: "菜单权限",
        beLate: "迟到",
        leaveEarly: "早退",
        overtime: "加班",
        tips3: "此操作会删除该证件，是否删除？",
        hint: "提示",
        managerName: "账户名称",
        tips4: "请注意该账户名称已被使用，请修改账户名",
        superManager: "超级管理员",
        ordinaryManager: "普通管理员",
        tips5: "添加设备失败:设备sn已存在",
        PunchType: "打卡类型",
        plan: "安排",
        ActualAttendanceTime: "实际出勤时长",
        yyyymmdd: "日期",
        ProductMicrocosmic: "产品微观",
        SchedulingManagementSystem: "排班管理系统",
        onlineShoppingMall: "线上商城",
        partner: "合作伙伴",
        AboutUs: "关于我们",
        allRightReserved: "版权所有",
        contactUs: "联系我们",
        content1: "轻松实现企业级人员管理",
        content2: "快速进行人员排班、表格导出等繁琐功能",
        content3: "智能楼宇；智能物业管理；监控系统；防盗系统；电子商贸；网站建立等",
        content4: "打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
        content5: "我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
        content6: "以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
        title3: "企业从事于",
        title4: "核心理念",
        title5: "团队作风",
        title6: "企业精神",
        btn1: "体验使用",
        BayAreaTechnology: "湾区科技",
        Macao: "澳门",
        MacaoContent1: "聚我智慧",
        MacaoContent2: "掌控精彩",
        MacaoContent3: "给您惊喜",
        MacaoContent4: "先科新世纪，引领创辉煌。",
        MacaoContent5: "共襄大湾区梦，共创美好未来。",
        gongSi1: "公司名称",
        gongSi2: "泽兆生软件开发中心",
        gongSi3: "经营范围",
        gongSi4: "一般项目：人工智能理论与算法软件开发；人工智能基础软件开发；软件开发；软件销售；互联网销售（除销售需要许可的商品）；计算机软硬件及辅助设备零售；销售代理。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）",
        gongSi5: "肆季映集文化活动策划工作室",
        gongSi6: "一般项目：组织文化艺术交流活动；摄像及视频制作服务；摄影扩印服务。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）",
        gongSi7: "裕丰通讯水电工程公司",
        gongSi8: "建设工程施工;建设工程设计;道路货物运输（不含危险货物）;通讯设备销售;建筑材料销售;软件开发;装卸搬运;劳务服务（不含劳务派遣）。",
        IntelligentUnlocking: "智能开锁系统",
        ScienceAndInnovationLife: "科创生活",
        CommittedTo: "致力湾区科技未来",
        theNumberOfUsers: "使用人数",
        serviceTeam: "服务团队",
        ao: "澳",
    },
}
